/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenericBenefit } from './GenericBenefit';
import {
    GenericBenefitFromJSON,
    GenericBenefitFromJSONTyped,
    GenericBenefitToJSON,
    GenericBenefitToJSONTyped,
} from './GenericBenefit';

/**
 * 
 * @export
 * @interface ProcedureSection
 */
export interface ProcedureSection {
    /**
     * 
     */
    procedure_code?: string;
    /**
     * 
     */
    procedure_code_definition?: string;
    /**
     * 
     */
    deductibles?: Array<GenericBenefit>;
    /**
     * 
     */
    coinsurances?: Array<GenericBenefit>;
    /**
     * 
     */
    benefit_descriptions?: Array<GenericBenefit>;
}

/**
 * Check if a given object implements the ProcedureSection interface.
 */
export function instanceOfProcedureSection(value: object): value is ProcedureSection {
    return true;
}

export function ProcedureSectionFromJSON(json: any): ProcedureSection {
    return ProcedureSectionFromJSONTyped(json, false);
}

export function ProcedureSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcedureSection {
    if (json == null) {
        return json;
    }
    return {
        
        'procedure_code': json['procedure_code'] == null ? undefined : json['procedure_code'],
        'procedure_code_definition': json['procedure_code_definition'] == null ? undefined : json['procedure_code_definition'],
        'deductibles': json['deductibles'] == null ? undefined : ((json['deductibles'] as Array<any>).map(GenericBenefitFromJSON)),
        'coinsurances': json['coinsurances'] == null ? undefined : ((json['coinsurances'] as Array<any>).map(GenericBenefitFromJSON)),
        'benefit_descriptions': json['benefit_descriptions'] == null ? undefined : ((json['benefit_descriptions'] as Array<any>).map(GenericBenefitFromJSON)),
    };
}

export function ProcedureSectionToJSON(json: any): ProcedureSection {
    return ProcedureSectionToJSONTyped(json, false);
}

export function ProcedureSectionToJSONTyped(value?: ProcedureSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'procedure_code': value['procedure_code'],
        'procedure_code_definition': value['procedure_code_definition'],
        'deductibles': value['deductibles'] == null ? undefined : ((value['deductibles'] as Array<any>).map(GenericBenefitToJSON)),
        'coinsurances': value['coinsurances'] == null ? undefined : ((value['coinsurances'] as Array<any>).map(GenericBenefitToJSON)),
        'benefit_descriptions': value['benefit_descriptions'] == null ? undefined : ((value['benefit_descriptions'] as Array<any>).map(GenericBenefitToJSON)),
    };
}

